import { toInteger } from 'lodash';
import { createCanvas } from '@/utils/file-kit';
import type { ILayerProps, ISize } from '@/version-types';
import { renderLayerContentToCanvas } from './render-to-canvas';

export const renderLayerToStage = async (
    layer: ILayerProps,
    identity: string,
    stageSize: ISize,
): Promise<HTMLCanvasElement | undefined> => {
    const layerImage = await renderLayerContentToCanvas(layer, identity, false);
    if (!layerImage) return;

    const { width, height, left, top, opacity, rotate } = layer;
    const { width: stageWidth, height: stageHeight } = stageSize;
    const resultWidth = toInteger(width);
    const resultHeight = toInteger(height);
    const centerPoint = {
        x: resultWidth / 2 + left,
        y: resultHeight / 2 + top,
    };
    const drawOffsetPoint = {
        x: -resultWidth / 2,
        y: -resultHeight / 2,
    };

    const { canvas: destCanvas, ctx: destCtx } = createCanvas(stageWidth, stageHeight);
    destCtx.translate(centerPoint.x, centerPoint.y);
    destCtx.rotate((Math.PI / 180) * rotate);
    destCtx.globalAlpha = opacity;
    destCtx.drawImage(
        layerImage,
        0,
        0,
        resultWidth,
        resultHeight,
        drawOffsetPoint.x,
        drawOffsetPoint.y,
        resultWidth,
        resultHeight,
    );

    return destCanvas;
};
